import { useNavigate } from "react-router-dom";
import styles from "./AgentScriptFull.module.css";

const AgentScriptFull = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2>📝 Agent Script: Luxury Flats Assistant</h2>
        <div className={styles.buttons}>
          <button onClick={() => navigate("/dashboard")} className={styles.backBtn}>
            ← Back to Dashboard
          </button>
          <button className={styles.editBtn}>✏️ Edit Script</button>
        </div>
      </div>

      <div className={styles.card}>
        <h3>Initial Contact Script – Luxury Flats</h3>
        <div className={styles.scriptContent}>
          <p>
            "Hello, my name is [Agent Name] from [Company Name]. I'm calling regarding your interest in luxury flats in Pune.
            We have some exclusive properties that might be a perfect fit for you.
          </p>
          <p>
            May I take a moment to understand what you're looking for in a luxury flat? Are you interested in 2BHK, 3BHK, or larger configurations?
          </p>
          <p>
            Our properties offer premium amenities such as [mention 2–3 key amenities, e.g., rooftop pool, concierge service, smart home features].
            We also have flexible payment plans available.
          </p>
          <p>
            Would you be open to a brief virtual tour or a visit to our experience center this week? We have slots available on [Day] at [Time] or [Day] at [Time].
          </p>
          <p>
            If now isn't a good time, when would be a better time for me to call you back?
          </p>
          <p>Thank you for your time. We look forward to helping you find your dream home."</p>
        </div>
        <p className={styles.footer}>Last edited on: July 18, 2024 by John Doe</p>

        <div className={styles.footerBtns}>
          <button className={styles.cancelBtn}>Cancel</button>
          <button className={styles.saveBtn}>Save Changes</button>
        </div>
      </div>
    </div>
  );
};

export default AgentScriptFull;
